import './App.css';
// import Header from "./component/layout/Header/Header.js";
// import Footer from "./component/layout/Footer/Footer.js";
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import WebFont from "webfontloader";
import React, { useEffect, useState, useLayoutEffect, lazy, Suspense } from "react";
import Home from "./component/Home/Home.jsx";
import Contact from "./component/Contact/Contact.jsx";
import Footer from './component/layout/Footer/Footer.js'
import store from "./store.js"
import { loadUser } from './actions/userAction';
import UserOptions from './component/layout/Header/UserOptions';
import CurrencySwitcher from './component/layout/CurrencySwitcher/CurrencySwitcher';
import { useSelector, useDispatch } from "react-redux";
import InfluencerRedirect from './component/InfluencerRedirect.jsx';
// import { useNavigate } from "react-router-dom";

import { logout } from "./actions/userAction";
import { trackPageView } from "./utils/analytics";


// import ProtectedRoute from './component/Route/ProtectedRoute';

// NIZAR CODE
import $ from "jquery";
import './assets/css/animate.min.css';
import './assets/css/magnific-popup.css';
import './assets/css/meanmenu.css';
import './assets/css/slick.css';
import './assets/css/bootstrap.min.css';
import './assets/css/fontawesome-all.min.css';
import './assets/css/themify-icons.css';
import './assets/css/nice-select.css';
import './assets/css/ui-range-slider.css';
import './assets/css/main.css';
import '../node_modules/jquery/dist/jquery.min.js';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import '../node_modules/popper.js/dist/popper.min.js';

import bravelogo from "./assets/img/logo/BRAVE-logo.png";
import menu_bannerwomen from "./assets/img/banner/menu/WOMEN.jpg";
import menu_bannermen from "./assets/img/banner/menu/MEN.jpg";
import menu_banneraccessories from "./assets/img/banner/menu/ACCESSORIES.jpg";
import products_1 from "./assets/img/products/product-1.jpg";
import products_2 from "./assets/img/products/product-2.jpg";
import products_3 from "./assets/img/products/product-3.jpg";

import ProtectedRoute from "./utils/protectedRoute";
import AuthenticatedRoute from "./utils/authenticatedRoute";
import RouteSeo from "./component/layout/RouteSeo";

// Pages load on demand so the first visit only downloads the code it needs
const Profile = lazy(() => import("./component/profile/Profile.jsx"));
const About = lazy(() => import("./component/About/About.jsx"));
const Cart = lazy(() => import("./component/Cart/Cart.jsx"));
const Checkout = lazy(() => import("./component/Checkout/Checkout.jsx"));
const Error = lazy(() => import("./component/Error/Error.jsx"));
const Faq = lazy(() => import("./component/Faq/Faq.jsx"));
const ShippingPolicy = lazy(() => import("./component/ShippingPolicy/ShippingPolicy.jsx"));
const ReturnsRefunds = lazy(() => import("./component/ReturnsRefunds/ReturnsRefunds.jsx"));
const PaymentMethod = lazy(() => import("./component/PaymentMethod/PaymentMethod.jsx"));
const PrivacyPolicy = lazy(() => import("./component/PrivacyPolicy/PrivacyPolicy.jsx"));
const TermsConditions = lazy(() => import("./component/TermsConditions/TermsConditions.jsx"));
const Shop = lazy(() => import("./component/Shop/Shop.jsx"));
const ShopCategory = lazy(() => import("./component/Shop/Shop2.jsx"));
const Signin = lazy(() => import("./component/SignIn/SignIn.jsx"));
const Signup = lazy(() => import("./component/SignUp/SignUp.jsx"));
const Login = lazy(() => import("./component/Login/Login.jsx"));
const Search = lazy(() => import("./component/Search/Search.jsx"));
const ProductDetails = lazy(() => import("./component/Product/ProductDetails"));
const VerifyEmail = lazy(() => import("./component/VerifyEmail/VerifyEmail.jsx"));
const UpdateProfile = lazy(() => import("./component/profile/UpdateProfile"));
const Shipping = lazy(() => import("./component/Shipping/Shipping.jsx"));
const UpdatePassword = lazy(() => import("./component/profile/UpdatePassword.jsx"));
const ForgotPassword = lazy(() => import("./component/profile/ForgotPassword.jsx"));
const ResetPassword = lazy(() => import("./component/profile/ResetPassword.jsx"));
const ConfirmOrder = lazy(() => import("./component/Shipping/ConfirmOrder.jsx"));
const ConfirmPayment = lazy(() => import("./component/payment/ConfirmPayment.jsx"));
const OrderSuccess = lazy(() => import("./component/Cart/OrderSuccess.jsx"));
const MyOrders = lazy(() => import("./component/Order/MyOrders.jsx"));
const OrderDetails = lazy(() => import("./component/Order/OrderDetails.jsx"));
const STAFF_ROLES = ["admin", "manager"];

const Dashboard = lazy(() => import("./component/admin/Dashboard.jsx"));
const PopupAnalytics = lazy(() => import("./component/admin/PopupAnalytics.jsx"));
const PopupLeads = lazy(() => import("./component/admin/PopupLeads.jsx"));
const Influencers = lazy(() => import("./component/admin/Influencers.jsx"));
const ProductList = lazy(() => import("./component/admin/ProductList.jsx"));
const NewProduct = lazy(() => import("./component/admin/NewProduct"));
const UpdateProduct = lazy(() => import("./component/admin/UpdateProduct.jsx"));
const OrderList = lazy(() => import("./component/admin/OrderList.jsx"));
const ProcessOrder = lazy(() => import("./component/admin/ProcessOrder.jsx"));
const UsersList = lazy(() => import("./component/admin/UsersList.jsx"));
const UpdateUser = lazy(() => import("./component/admin/UpdateUser.jsx"));
const UserCredit = lazy(() => import("./component/admin/UserCredit.jsx"));
const ProductReviews = lazy(() => import("./component/admin/ProductReviews.jsx"));
const PromoCodes = lazy(() => import("./component/admin/PromoCodes.jsx"));
const BogoOffer = lazy(() => import("./component/admin/BogoOffer.jsx"));
const FreeGiftList = lazy(() => import("./component/admin/FreeGiftList.jsx"));
const FreeGiftForm = lazy(() => import("./component/admin/FreeGiftForm.jsx"));
const ContactInquiries = lazy(() => import("./component/admin/ContactInquiries.jsx"));
const Charges = lazy(() => import("./component/admin/Charges.jsx"));


const AppFooter = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.toLowerCase().startsWith("/admin");

    return isAdminRoute ? null : <Footer />;
};

const AnalyticsPageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location);
    }, [location]);

    return null;
};

const normalizeProductGender = (gender = "") => {
    const normalized = String(gender).trim().toLowerCase();
    if (normalized === "man" || normalized === "men") return "Men";
    if (normalized === "woman" || normalized === "women") return "Women";
    if (normalized === "unisex") return "Unisex";
    return "";
};

const buildShopFilterUrl = ({ category, subcategory, gender, sale }) => {
    const params = new URLSearchParams();
    if (category) params.set("category", category);
    if (subcategory) params.set("subcategory", subcategory);
    if (gender) params.set("gender", gender);
    if (sale) params.set("sale", "true");
    const query = params.toString();
    return `/shop${query ? `?${query}` : ""}`;
};

function App() {

    const dispatch = useDispatch();
    // const navigate = useNavigate();
    
    useLayoutEffect(()=>{
        ProductData(); //Doesn't want until render is completed 
    }, [])
    
    const { cartItems } = useSelector((state) => state.cart);

    // let manProduct = [];
    // let womanProduct = [];
    // const { userIfo } = loadUser();

    function logoutUser() {
        dispatch(logout()).then(()=>{
            // alert(this.props.value)
            // navigate("/Signup");
            window.location.reload();
         })
        
    }
    
    //add discount pop here

    const {isAuthenticated, user} = useSelector((state)=> state.user);

    const isAdminLoggedIn = isAuthenticated && STAFF_ROLES.includes(user?.role);
    const[manProduct, setManProduct] = useState([]);
    const[womanProduct, setWomanProduct] = useState([]);
    const[accessoryCategories, setAccessoryCategories] = useState([]);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

    // RDX first, then TopTen, then Green Hill, everything else after (original order kept)
    const categoryRank = (name) => {
        const key = String(name || '').toLowerCase().replace(/\s+/g, '');
        if (key.includes('rdx')) return 0;
        if (key.includes('topten')) return 1;
        if (key.includes('greenhill')) return 2;
        return 3;
    };
    const sortByCategory = (list, getName) =>
        [...list].sort((a, b) => categoryRank(getName(a)) - categoryRank(getName(b)));

    const ProductData = () => {
        fetch("/api/v1/products?keyword=&limit=1000")
          .then(response => {
            // console.log('fetchUserData',response);
            // console.log('fetchUserData',response.json());
            return response.json()
          })
          .then(data => {
            // console.log('Product Data--->',data);
                let tempManProductArray = [];
                let tempWomanProductArray = [];
                let tempManCategoryArray = [];
                let tempWomanCategoryArray = [];
                const tempAccessoryCategories = [];
                const productList = Array.isArray(data?.products) ? data.products : [];
                if(productList.length){
                    for(let i = 0; i< productList.length; i++){
                        const productGender = normalizeProductGender(productList[i].gender);
                        if(productList[i].subcategory === 'Accessories' && productList[i].category && !tempAccessoryCategories.includes(productList[i].category)){
                            tempAccessoryCategories.push(productList[i].category);
                        }
                        if((productGender === 'Men' || productGender === 'Unisex') && !tempManCategoryArray.includes(productList[i].category)){
                            tempManProductArray.push(productList[i]);
                            tempManCategoryArray.push(productList[i].category);
                        }
                        if((productGender === 'Women' || productGender === 'Unisex') && !tempWomanCategoryArray.includes(productList[i].category)){
                            tempWomanProductArray.push(productList[i]);
                            tempWomanCategoryArray.push(productList[i].category);
                        }
                    }
                    // console.log('tempManProductArray',tempManProductArray);
                    // console.log('tempWomanProductArray',tempWomanProductArray);
                }
                setManProduct(sortByCategory(tempManProductArray, (item) => item.category));
                setWomanProduct(sortByCategory(tempWomanProductArray, (item) => item.category));
                setAccessoryCategories(sortByCategory(tempAccessoryCategories, (name) => name));
                // setManProduct(new Set (...tempManProductArray));
                // setWomanProduct(new Set (...tempWomanProductArray));
                // debugger;
                // manProduct = new Set (...tempManProductArray);
                // womanProduct = new Set (...tempWomanProductArray);
            // updateUserInfo(data);
            // if(data.user.role === 'admin'){
            //     // navigate("/admin/dashboard");
            //     setIsAdminLoggedIn(true);
            // }
          })
          .catch(() => {
            setManProduct([]);
            setWomanProduct([]);
            setAccessoryCategories([]);
          })
        // const { userInformation2 } = await http.get(`/api/v1/me`);
      }

    

    // useEffect(() => {
    //     ProductData();
    // },[])

    

    

    // function getCategory(){
    //     let tempManProductArray = [];
    //     let tempWomanProductArray = [];
    //     if(products){
    //         for(let i = 0; i< products.length; i++){
    //             if(products[i].gender === 'Man'){
    //                 tempManProductArray.push(products[i].category);
    //             }
    //             if(products[i].gender === 'Woman'){
    //                 tempWomanProductArray.push(products[i].category);
    //             }
    //         }
    //     }
    //     manProduct = new Set (...tempManProductArray);
    //     womanProduct = new Set (...tempWomanProductArray);

    // }

    // const getCategory = useCallback((manProduct,womanProduct) => {
    //     let tempManProductArray = [];
    //     let tempWomanProductArray = [];
    //     if(products){
    //         for(let i = 0; i< products.length; i++){
    //             if(products[i].gender === 'Man'){
    //                 tempManProductArray.push(products[i].category);
    //             }
    //             if(products[i].gender === 'Woman'){
    //                 tempWomanProductArray.push(products[i].category);
    //             }
    //         }
    //     }
    //     manProduct = new Set (...tempManProductArray);
    //     womanProduct = new Set (...tempWomanProductArray);
    //   }, [products]);

    //   useEffect(() => {
    //     dispatch(getProduct());
    // },[dispatch])

    // useEffect(() => {
    //     getCategory();
    // },[getCategory])

    // getCategory();

    useEffect(() => {



        //Cart Plus Minus Js
        $(".cart-plus-minus").append('<div class="dec qtybutton">-</div><div class="inc qtybutton">+</div>');
        $(".qtybutton").on("click", function () {
            var $button = $(this);
            var oldValue = $button.parent().find("input").val();
            var newVal;
            if ($button.text() === "+") {
                newVal = parseFloat(oldValue) + 1;
            } else if (oldValue > 0) {
                // Don't allow decrementing below zero
                newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
            $button.parent().find("input").val(newVal);
        });
      
        // SCROLL HEADER STICKY
        $(window).on("scroll", function () {
            var scroll = $(window).scrollTop();
            if (scroll < 245) {
                $("#header-sticky").removeClass("sticky");
            } else {
                $("#header-sticky").addClass("sticky");
            }
        });
        // SCROLL HEADER STICKY
      
        // SEARCH TOGGLE START
        $(".search-toggle").on("click", function () {
            $(".search__area").addClass("search-active");
            setTimeout(function () {
                var input = document.getElementById("header-search-input");
                if (input) { input.focus(); }
            }, 150);
        });
        $(document).on("keydown", function (e) {
            if (e.key === "Escape") {
                $(".search__area").removeClass("search-active");
            }
        });
        $(".search-close-btn").on("click", function () {
            $(".search__area").removeClass("search-active");
        });
        // SEARCH TOGGLE END

        // Show Login Toggle Js
        $('#showlogin').on('click', function () {
            $('#checkout-login').slideToggle(900);
        });

        ////////////////////////////////////////////////////
        // Show Coupon Toggle Js
        $('#showcoupon').on('click', function () {
            $('#checkout_coupon').slideToggle(900);
        });


        // SCROLL TO TOP
        var btn = $('#scroll_to_top');

        $(window).scroll(function() {
            if ($(window).scrollTop() > 300) {
                btn.addClass('show');
            } else {
                btn.removeClass('show');
            }
        });

        btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({scrollTop:0}, '300');
        });
        // SCROLL TO TOP


        // MEANMENU
        (function ($) {
            $.fn.meanmenu = function (options) {
                var defaults = {
                    meanMenuTarget: $(this), // Target the current HTML markup you wish to replace
                    meanMenuContainer: 'body', // Choose where meanmenu will be placed within the HTML
                    meanMenuClose: "X", // single character you want to represent the close menu button
                    meanMenuCloseSize: "18px", // set font size of close button
                    meanMenuOpen: "<span /><span /><span />", // text/markup you want when menu is closed
                    meanRevealPosition: "right", // left right or center positions
                    meanRevealPositionDistance: "0", // Tweak the position of the menu
                    meanRevealColour: "", // override CSS colours for the reveal background
                    meanScreenWidth: "480", // set the screen width you want meanmenu to kick in at
                    meanNavPush: "", // set a height here in px, em or % if you want to budge your layout now the navigation is missing.
                    meanShowChildren: true, // true to show children in the menu, false to hide them
                    meanExpandableChildren: true, // true to allow expand/collapse children
                    meanExpand: "+", // single character you want to represent the expand for ULs
                    meanContract: "-", // single character you want to represent the contract for ULs
                    meanRemoveAttrs: false, // true to remove classes and IDs, false to keep them
                    onePage: false, // set to true for one page sites
                    meanDisplay: "block", // override display method for table cell based layouts e.g. table-cell
                    removeElements: "" // set to hide page elements
                };
                options = $.extend(defaults, options);
    
                // get browser width
                var currentWidth = window.innerWidth || document.documentElement.clientWidth;
    
                return this.each(function () {
                    var meanMenu = options.meanMenuTarget;
                    var meanContainer = options.meanMenuContainer;
                    var meanMenuClose = options.meanMenuClose;
                    var meanMenuCloseSize = options.meanMenuCloseSize;
                    var meanMenuOpen = options.meanMenuOpen;
                    var meanRevealPosition = options.meanRevealPosition;
                    var meanRevealPositionDistance = options.meanRevealPositionDistance;
                    var meanRevealColour = options.meanRevealColour;
                    var meanScreenWidth = options.meanScreenWidth;
                    var meanNavPush = options.meanNavPush;
                    var meanRevealClass = ".meanmenu-reveal";
                    var meanShowChildren = options.meanShowChildren;
                    var meanExpandableChildren = options.meanExpandableChildren;
                    var meanExpand = options.meanExpand;
                    var meanContract = options.meanContract;
                    var meanRemoveAttrs = options.meanRemoveAttrs;
                    var onePage = options.onePage;
                    var meanDisplay = options.meanDisplay;
                    var removeElements = options.removeElements;

                    //detect known mobile/tablet usage
                    var isMobile = false;
                    if ( (navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i)) || (navigator.userAgent.match(/Android/i)) || (navigator.userAgent.match(/Blackberry/i)) || (navigator.userAgent.match(/Windows Phone/i)) ) {
                        isMobile = true;
                    }

                    if ( (navigator.userAgent.match(/MSIE 8/i)) || (navigator.userAgent.match(/MSIE 7/i)) ) {
                        // add scrollbar for IE7 & 8 to stop breaking resize function on small content sites
                        $('html').css("overflow-y" , "scroll");
                    }

                    var meanRevealPos = "";
                    var meanCentered = function() {
                        if (meanRevealPosition === "center") {
                            var newWidth = window.innerWidth || document.documentElement.clientWidth;
                            var meanCenter = ( (newWidth/2)-22 )+"px";
                            meanRevealPos = "left:" + meanCenter + ";right:auto;";

                            if (!isMobile) {
                                $('.meanmenu-reveal').css("left",meanCenter);
                            } else {
                                $('.meanmenu-reveal').animate({
                                    left: meanCenter
                                });
                            }
                        }
                    };

                    var menuOn = false;
                    var meanMenuExist = false;

                    if (meanRevealPosition === "right") {
                        meanRevealPos = "right:" + meanRevealPositionDistance + ";left:auto;";
                    }
                    if (meanRevealPosition === "left") {
                        meanRevealPos = "left:" + meanRevealPositionDistance + ";right:auto;";
                    }
                    // run center function
                    meanCentered();

                    // set all styles for mean-reveal
                    var $navreveal = "";

                    var meanInner = function() {
                        // get last class name
                        if ($($navreveal).is(".meanmenu-reveal.meanclose")) {
                            $navreveal.html(meanMenuClose);
                        } else {
                            $navreveal.html(meanMenuOpen);
                        }
                    };

                    // re-instate original nav (and call this on window.width functions)
                    var meanOriginal = function() {
                        $('.mean-bar,.mean-push').remove();
                        $(meanContainer).removeClass("mean-container");
                        $(meanMenu).css('display', meanDisplay);
                        menuOn = false;
                        meanMenuExist = false;
                        $(removeElements).removeClass('mean-remove');
                    };

                    // navigation reveal
                    var showMeanMenu = function() {
                        var meanStyles = "background:"+meanRevealColour+";color:"+meanRevealColour+";"+meanRevealPos;
                        if (currentWidth <= meanScreenWidth) {
                            $(removeElements).addClass('mean-remove');
                            meanMenuExist = true;
                            // add class to body so we don't need to worry about media queries here, all CSS is wrapped in '.mean-container'
                            $(meanContainer).addClass("mean-container");
                            $('.mean-container').prepend('<div class="mean-bar"><a href="#nav" class="meanmenu-reveal" style="'+meanStyles+'">Show Navigation</a><nav class="mean-nav"></nav></div>');

                            //push meanMenu navigation into .mean-nav
                            var meanMenuContents = $(meanMenu).html();
                            $('.mean-nav').html(meanMenuContents);

                            // remove all classes from EVERYTHING inside meanmenu nav
                            if(meanRemoveAttrs) {
                                $('nav.mean-nav ul, nav.mean-nav ul *').each(function() {
                                    // First check if this has mean-remove class
                                    if ($(this).is('.mean-remove')) {
                                        $(this).attr('class', 'mean-remove');
                                    } else {
                                        $(this).removeAttr("class");
                                    }
                                    $(this).removeAttr("id");
                                });
                            }

                            // push in a holder div (this can be used if removal of nav is causing layout issues)
                            $(meanMenu).before('<div class="mean-push" />');
                            $('.mean-push').css("margin-top",meanNavPush);

                            // hide current navigation and reveal mean nav link
                            $(meanMenu).hide();
                            $(".meanmenu-reveal").show();

                            // turn 'X' on or off
                            $(meanRevealClass).html(meanMenuOpen);
                            $navreveal = $(meanRevealClass);

                            //hide mean-nav ul
                            $('.mean-nav ul').hide();

                            // hide sub nav
                            if(meanShowChildren) {
                                // allow expandable sub nav(s)
                                if(meanExpandableChildren){
                                    $('.mean-nav ul ul').each(function() {
                                        if($(this).children().length){
                                            $(this,'li:first').parent().append('<a class="mean-expand font-18px" href="#">'+ meanExpand +'</a>');
                                        }
                                    });
                                    $('.mean-expand').on("click",function(e){
                                        e.preventDefault();
                                            if ($(this).hasClass("mean-clicked")) {
                                                $(this).text(meanExpand);
                                            $(this).prev('ul').slideUp(300, function(){});
                                        } else {
                                            $(this).text(meanContract);
                                            $(this).prev('ul').slideDown(300, function(){});
                                        }
                                        $(this).toggleClass("mean-clicked");
                                    });
                                } else {
                                    $('.mean-nav ul ul').show();
                                }
                            } else {
                                $('.mean-nav ul ul').hide();
                            }

                            // add last class to tidy up borders
                            $('.mean-nav ul li').last().addClass('mean-last');
                            $navreveal.removeClass("meanclose");
                            $($navreveal).click(function(e){
                                e.preventDefault();
                                if( menuOn === false ) {
                                    $navreveal.css("text-align", "center");
                                    $navreveal.css("text-indent", "0");
                                    $navreveal.css("font-size", meanMenuCloseSize);
                                    $('.mean-nav ul:first').slideDown();
                                    menuOn = true;
                                } else {
                                    $('.mean-nav ul:first').slideUp();
                                    menuOn = false;
                                }
                                    $navreveal.toggleClass("meanclose");
                                    meanInner();
                                    $(removeElements).addClass('mean-remove');
                            });

                            // for one page websites, reset all variables...
                            if ( onePage ) {
                                $('.mean-nav ul > li > a:first-child').on( "click" , function () {
                                    $('.mean-nav ul:first').slideUp();
                                    menuOn = false;
                                    $($navreveal).toggleClass("meanclose").html(meanMenuOpen);
                                });
                            }
                        } else {
                            meanOriginal();
                        }
                    };

                    if (!isMobile) {
                        // reset menu on resize above meanScreenWidth
                        $(window).resize(function () {
                            currentWidth = window.innerWidth || document.documentElement.clientWidth;
                            if (currentWidth > meanScreenWidth) {
                                meanOriginal();
                            } else {
                                meanOriginal();
                            }
                            if (currentWidth <= meanScreenWidth) {
                                showMeanMenu();
                                meanCentered();
                            } else {
                                meanOriginal();
                            }
                        });
                    }

                    $(window).resize(function () {
                        // get browser width
                        currentWidth = window.innerWidth || document.documentElement.clientWidth;

                        if (!isMobile) {
                            meanOriginal();
                            if (currentWidth <= meanScreenWidth) {
                                showMeanMenu();
                                meanCentered();
                            }
                        } else {
                            meanCentered();
                            if (currentWidth <= meanScreenWidth) {
                                if (meanMenuExist === false) {
                                    showMeanMenu();
                                }
                            } else {
                                meanOriginal();
                            }
                        }
                    });

                    // run main menuMenu function on load
                    showMeanMenu();
                });
            };
        })($);

        $(document).ready(function () {
            $("#mobile-menu").meanmenu({
                meanMenuContainer: ".mobile-menu",
                meanScreenWidth: "991",
            });
        });

        WebFont.load({
            google:{
                families:["Roboto", "Droid Sans", "chilanka"]
            }
        });
            store.dispatch(loadUser());
        // getStripeApiKey();
    },[])

  return (
    //Java Logic here
    <>
      {/* //html logic here */}
      {/*<UserOptions/>*/}
      <BrowserRouter>
      {/* <BrowserRouter> */}
          <AnalyticsPageTracker />
          <header>
              <div className="header-area">
                  <div className="header-top pl-60 pr-60 d-none d-md-block">
                      <div className="row align-items-center">
                          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-4">
                              <div className="currency has-n-select display-none">
                                  <select name="currency" id="currency">
                                      <option value="USD">USD</option>
                                      <option value="BHD">BHD</option>
                                  </select>
                              </div>
                              <div className="language has-n-select display-none">
                                  <select name="language" id="language">
                                      <option value="english">English</option>
                                      <option value="arabic">Arabic</option>
                                  </select>
                              </div>
                          </div>
                          {/* HIDDEN: 15% Offer Banner
                          <div className="col-xxl-4 col-xl-4 d-none d-xl-block">
                                <p className="white-text center-text">Early Bird Offer, Get 15% Off On All Products. <a href='/shop' color='blue'> BUY NOW!!! </a></p>
                          </div>
                          */}
                          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-8">
                              <div className="topbar-menu">
                                  {/* <ul className="end-text">
                                      <li><a href="/About">About Us</a></li>
                                      <li><a href="#">Newsletter</a></li>
                                      <li><a href="#">Contact Us</a></li>
                                      <li><a href="">FAQs</a></li>
                                  </ul> */}
                              </div>
                          </div>
                      </div>
                  </div>
                  <div id="header-sticky" className="header-main header-main-2 header-padding-2 pl-60 pr-60 header-sticky header-sticky-white border-bottom-gray">
                      <div className="mobile-header-row">
                          <div className="mobile-header-left">
                              <button type="button" className="header-bar-btn header-bar-btn-black mobile-menu-trigger" data-bs-toggle="modal" data-bs-target="#offCanvasModal" aria-label="Open menu"><span></span><span></span><span></span></button>
                              <a href="#search" onClick={(e) => e.preventDefault()} className="mobile-search-trigger search-toggle" aria-label="Search"><i className="fal fa-search"></i></a>
                          </div>
                          <a href="/" className="mobile-header-logo"><img src={bravelogo} alt="BRAVE" /></a>
                          <div className="mobile-header-right">
                              <CurrencySwitcher />
                              <a href="/Cart" className="mobile-cart-link" aria-label={`Cart, ${cartItems.length} items`}><i className="fal fa-shopping-cart"></i><span>{cartItems.length}</span></a>
                          </div>
                      </div>
                      <div className="row align-items-center desktop-header-row">
                          <div className="col-xxl-3 col-xl-2 col-lg-2 col-md-4 col-sm-6 col-4">
                              <div className="header-left">
                                  <div className="logo pr-55 d-inline-block">
                                      <a href="/"><img src={bravelogo} alt="BRAVE Athleisure" width="102" height="52" /></a>
                                  </div>
                              </div> 
                          </div>
                          <div className="col-xxl-6 col-xl-8 col-lg-8 d-none d-lg-block">
                              <div className="main-menu p-rel d-flex align-items-center justify-content-center">
                                  <nav id="mobile-menu">
                                      <ul>
                                          <li><a href="/">Home</a></li>
                                          {/* <li className="static">
                                              <a href="/Shop">Shop <i className="icon-arrow-down"></i></a>
                                              <ul className="mega-menu mega-menu-2-col">
                                                  <li className="has-dropdown">
                                                      <a href="/Shop">CATEGORIES</a>
                                                      <ul className="has-dropdown">
                                                          <li><a href="/shop?subcategory=Clothing">Clothing</a></li>
                                                          <li><a href="/shop?subcategory=Footwear">Footwear</a></li>
                                                          <li><a href="/shop?subcategory=Accessories">Accessories</a></li>
                                                          <li><a href="/shop?subcategory=Posters">Posters</a></li>
                                                      </ul>
                                                  </li>
                                                  <li className="has-dropdown">
                                                      <a href="/shop?sale=true">SALE</a>
                                                      <ul className="has-dropdown">
                                                          <li><a href="/shop?sale=true&subcategory=Clothing">Clothing</a></li>
                                                          <li><a href="/shop?sale=true&subcategory=Footwear">Footwear</a></li>
                                                          <li><a href="/shop?sale=true&subcategory=Accessories">Accessories</a></li>
                                                          <li><a href="/shop?sale=true&subcategory=Posters">Posters</a></li>
                                                      </ul>
                                                  </li>
                                                  <li className="d-none d-xl-block">
                                                      <div className="menu-banner-wrapper p-rel">
                                                          <a className="w-img" href="/Shop">
                                                              <img src={menu_bannermen} alt="" />
                                                          </a>
                                                          <a href="/Shop" className="menu-banner-btn">men</a>
                                                      </div>
                                                  </li>
                                                  <li className="d-none d-lg-block">
                                                      <div className="menu-banner-wrapper p-rel">
                                                          <a className="w-img" href="/Shop">
                                                              <img src={menu_bannerwomen} alt="" />
                                                          </a>
                                                          <a href="/Shop" className="menu-banner-btn">women</a>
                                                      </div>
                                                  </li>
                                              </ul>
                                          </li> */}
                                          <li className="static">
                                              <a href="/Shop">Shop <i className="icon-arrow-down"></i></a>
                                              <ul className="mega-menu mega-menu-shop">
                                                  {manProduct.length > 0 && (
                                                      <li className="has-dropdown shop-mega-links">
                                                          <a href={buildShopFilterUrl({ gender: "Men" })}>MEN COLLECTION</a>
                                                          <ul className="has-dropdown">
                                                              {manProduct.map((cat,index) => (
                                                                <li key={index}><a href={buildShopFilterUrl({ category: cat.category, gender: "Men" })}>{cat.category}</a></li>
                                                            ))}
                                                          </ul>
                                                      </li>
                                                  )}
                                                  {womanProduct.length > 0 && (
                                                      <li className="has-dropdown shop-mega-links">
                                                          <a href={buildShopFilterUrl({ gender: "Women" })}>WOMEN COLLECTION</a>
                                                          <ul className="has-dropdown">
                                                              {womanProduct.map((cat,index) => (
                                                                <li key={index}><a href={buildShopFilterUrl({ category: cat.category, gender: "Women" })}>{cat.category}</a></li>
                                                            ))}
                                                          </ul>
                                                      </li>
                                                  )}
                                                  {accessoryCategories.length > 0 && (
                                                      <li className="has-dropdown shop-mega-links">
                                                          <a href={buildShopFilterUrl({ subcategory: "Accessories" })}>ACCESSORIES</a>
                                                          <ul className="has-dropdown">
                                                              {accessoryCategories.map((cat) => (
                                                                <li key={cat}><a href={buildShopFilterUrl({ subcategory: "Accessories", category: cat })}>{cat}</a></li>
                                                            ))}
                                                          </ul>
                                                      </li>
                                                  )}
                                                  {manProduct.length > 0 && (
                                                      <li className="d-none d-lg-block shop-mega-banner">
                                                          <div className="menu-banner-wrapper p-rel">
                                                              <a className="w-img" href={buildShopFilterUrl({ gender: "Men" })}>
                                                                  <img src={menu_bannermen} alt="Men's collection" />
                                                              </a>
                                                              <a href={buildShopFilterUrl({ gender: "Men" })} className="menu-banner-btn">men</a>
                                                          </div>
                                                      </li>
                                                  )}
                                                  {womanProduct.length > 0 && (
                                                      <li className="d-none d-lg-block shop-mega-banner">
                                                          <div className="menu-banner-wrapper p-rel">
                                                              <a className="w-img" href={buildShopFilterUrl({ gender: "Women" })}>
                                                                  <img src={menu_bannerwomen} alt="Women's collection" />
                                                              </a>
                                                              <a href={buildShopFilterUrl({ gender: "Women" })} className="menu-banner-btn">women</a>
                                                          </div>
                                                      </li>
                                                  )}
                                                  {accessoryCategories.length > 0 && (
                                                      <li className="d-none d-lg-block shop-mega-banner">
                                                          <div className="menu-banner-wrapper p-rel">
                                                              <a className="w-img" href={buildShopFilterUrl({ subcategory: "Accessories" })}>
                                                                  <img src={menu_banneraccessories} alt="Accessories collection" />
                                                              </a>
                                                              <a href={buildShopFilterUrl({ subcategory: "Accessories" })} className="menu-banner-btn">accessories</a>
                                                          </div>
                                                      </li>
                                                  )}
</ul>
                                          </li>
                                          <li><a className="sales-menu-link" href={buildShopFilterUrl({ sale: true })}>SALE</a></li>
                                          <li><a href="/Contact">Contact Us</a></li>
                                          <li><a href="/orders">My Orders</a></li>
                                          {/* <li><a href="/admin/dashboard">Admin</a></li> */}
                                          {/* {isAdminLoggedIn ? (
                                                <li><a href="/admin/dashboard">Admin</a></li>
                                            ) :
                                            (
                                                <li><a href="/Login">Admin</a></li>
                                            )} */}
                                            {isAdminLoggedIn ? (
                                                <li><Link to="/admin/dashboard">Admin</Link></li>
                                            ) :
                                            (
                                                <span></span>
                                            )}
                                          {/* <li><a href="#" onClick={() => goToAdmin()}>Admin</a></li> */}
                                      </ul>
                                  </nav>
                              </div>
                          </div>
                          <div className="col-xxl-3 col-xl-2 col-lg-2 col-md-8 col-sm-6 col-8">
                              <div className="header-right-wrapper d-flex align-items-center justify-content-end">
                                  <div className="header-right header-right-2 d-flex align-items-center justify-content-end">
                                        <CurrencySwitcher />
                                        <div className="profile-menu d-none d-xxl-inline-block">
                                            <button
                                                type="button"
                                                className="profile-menu-toggle"
                                                aria-label="Account menu"
                                                aria-expanded={isProfileMenuOpen}
                                                onClick={() => setIsProfileMenuOpen((isOpen) => !isOpen)}
                                            >
                                                <i className="fal fa-user" aria-hidden="true"></i>
                                            </button>
                                            {isProfileMenuOpen && (
                                                <div className="profile-menu-dropdown">
                                                    {isAuthenticated ? (
                                                        <>
                                                            <a href="/profile" onClick={() => setIsProfileMenuOpen(false)}>My account</a>
                                                            <button type="button" onClick={logoutUser}>Logout</button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <a href="/Login" onClick={() => setIsProfileMenuOpen(false)}>My account</a>
                                                            <a href="/Login" onClick={() => setIsProfileMenuOpen(false)}>Login / Register</a>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="header-icon header-icon-2 d-inline-block ml-30">
                                            <a href="#search" onClick={(e) => e.preventDefault()} className="search-toggle" aria-label="Search"><i className="fal fa-search"></i></a>
                                            <button className="d-none" type="button" data-bs-toggle="modal" data-bs-target="#cartMiniModal">
                                                <i className="fal fa-shopping-cart"></i><span>2</span>
                                            </button>
                                            <a href="/Cart" className="">
                                                <i className="fal fa-shopping-cart"></i><span>{cartItems.length}</span>
                                            </a>
                                        </div>
                                  </div>
                                  <div className="header-bar ml-20 d-lg-none">
                                      <button type="button" className="header-bar-btn header-bar-btn-black" data-bs-toggle="modal" data-bs-target="#offCanvasModal">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </header>
        

            <div className="cartmini__area">
                <div className="modal fade" id="cartMiniModal" tabIndex="-1" aria-labelledby="cartMiniModal" aria-hidden="true">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="cartmini__wrapper">
                            <div className="cartmini__top d-flex align-items-center justify-content-between">
                                <h4>Your Cart</h4>
                                <div className="cartminit__close">
                                    <button type="button" data-bs-toggle="modal" data-bs-target="#cartMiniModal" className="cartmini__close-btn"> <i className="fal fa-times"></i></button>
                                </div>
                            </div>
                            <div className="cartmini__list">
                                <ul>
                                    <li className="cartmini__item p-rel d-flex align-items-start">
                                        <div className="cartmini__thumb mr-15">
                                            <a href="/ProductDetails">
                                                <img src={products_1} alt=""></img>
                                            </a>
                                        </div>
                                        <div className="cartmini__content">
                                            <h3 className="cartmini__title">
                                                <a href="/ProductDetails">Form Armchair Walnut Base</a>
                                            </h3>
                                            <span className="cartmini__price">
                                                <span className="price">1 × $70.00</span>
                                            </span>
                                        </div>
                                        <a href="/Cart" className="cartmini__remove">
                                            <i className="fal fa-times"></i>
                                        </a>
                                    </li>
                                    <li className="cartmini__item p-rel d-flex align-items-start">
                                        <div className="cartmini__thumb mr-15">
                                            <a href="/ProductDetails">
                                                <img src={products_2} alt=""></img>
                                            </a>
                                        </div>
                                        <div className="cartmini__content">
                                            <h3 className="cartmini__title">
                                                <a href="/ProductDetails">Form Armchair Simon Legald</a>
                                            </h3>
                                            <span className="cartmini__price">
                                                <span className="price">1 × $95.99</span>
                                            </span>
                                        </div>
                                        <a href="/Cart" className="cartmini__remove">
                                            <i className="fal fa-times"></i>
                                        </a>
                                    </li>
                                    <li className="cartmini__item p-rel d-flex align-items-start">
                                        <div className="cartmini__thumb mr-15">
                                            <a href="/ProductDetails">
                                                <img src={products_3} alt=""></img>
                                            </a>
                                        </div>
                                        <div className="cartmini__content">
                                            <h3 className="cartmini__title">
                                                <a href="/ProductDetails">Antique Chinese Armchairs</a>
                                            </h3>
                                            <span className="cartmini__price">
                                                <span className="price">1 × $120.00</span>
                                            </span>
                                        </div>
                                        <a href="/Cart" className="cartmini__remove">
                                            <i className="fal fa-times"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="cartmini__total d-flex align-items-center justify-content-between">
                                <h5>Total</h5>
                                <span>$180.00</span>
                            </div>
                            <div className="cartmini__bottom">
                                <a href="/Cart" className="s-btn w-100 mb-20">view cart</a>
                                <a href="/" className="s-btn s-btn-2 w-100">checkout</a>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>


            <div className="search__area" onClick={(e) => { if (e.target === e.currentTarget) { e.currentTarget.classList.remove('search-active'); } }}>
                <div className="search-panel" role="dialog" aria-label="Search products">
                    <button type="button" className="search__close-btn search-close-btn" aria-label="Close search"><i className="fal fa-times"></i></button>
                    <div className="search-panel-inner">
                        <form
                            className="search-panel-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                const term = new FormData(e.currentTarget).get('q');
                                const trimmed = String(term || '').trim();
                                if (trimmed) {
                                    window.location.assign(`/shop?keyword=${encodeURIComponent(trimmed)}`);
                                }
                            }}
                        >
                            <i className="fal fa-search search-panel-icon" aria-hidden="true"></i>
                            <input id="header-search-input" name="q" type="text" placeholder="Search products" autoComplete="off" aria-label="Search products" />
                            <button type="submit" className="search-panel-submit">Search</button>
                        </form>
                        <div className="search-panel-suggest">
                            <span>Popular</span>
                            <a href="/shop?subcategory=Clothing">Clothing</a>
                            <a href="/shop?subcategory=Footwear">Footwear</a>
                            <a href="/shop?subcategory=Accessories">Accessories</a>
                            <a href="/shop?subcategory=Posters">Posters</a>
                            <a href="/shop?sale=true">Sale</a>
                        </div>
                    </div>
                </div>
            </div>


            <section className="offcanvas__area">
                <div className="modal fade" id="offCanvasModal" tabIndex="-1" aria-labelledby="offCanvasModal" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="offcanvas__wrapper">
                                <div className="offcanvas__top d-flex align-items-center mb-10 justify-content-between">
                                    <div className="logo">
                                        <a href="/">
                                        <img src={bravelogo} alt="logo" />
                                        </a>
                                    </div>
                                    <div className="offcanvas__close">
                                        <button className="offcanvas__close-btn" data-bs-toggle="modal" data-bs-target="#offCanvasModal">
                                            <svg viewBox="0 0 22 22">
                                                <path d="M12.41,11l5.29-5.29c0.39-0.39,0.39-1.02,0-1.41s-1.02-0.39-1.41,0L11,9.59L5.71,4.29c-0.39-0.39-1.02-0.39-1.41,0
                                                s-0.39,1.02,0,1.41L9.59,11l-5.29,5.29c-0.39,0.39-0.39,1.02,0,1.41C4.49,17.9,4.74,18,5,18s0.51-0.1,0.71-0.29L11,12.41l5.29,5.29
                                                C16.49,17.9,16.74,18,17,18s0.51-0.1,0.71-0.29c0.39-0.39,0.39-1.02,0-1.41L12.41,11z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="offcanvas__content p-relative z-index-1">
                                    <div className="canvas__menu fix ">
                                        <div className="mobile-menu"></div>
                                    </div>
                                    <div className="offcanvas__action mb-15">
                                        {!isAuthenticated? (
                                        <a href="/Login">Login</a>
                                        ) : (
                                        <a href="/profile" className="d-block">
                                            <i className="fa fa-user-edit"></i>
                                            &nbsp;Profile
                                        </a>
                                        )}
                                        {!isAuthenticated? (
                                            <span></span>
                                        ) : (
                                            <a href="/Login" onClick={(e) => { e.preventDefault(); logoutUser(); }} className="d-xxl-inline-block cursor-pointer">
                                                <i className="fa fa-sign-out"></i>
                                                &nbsp;Logout
                                            </a>
                                        )}
                                    </div>
                                    <div className="offcanvas__action mb-15 d-sm-block">
                                        <a href="/Cart" className="has-tag">
                                            <i className="far fa-shopping-bag"></i>
                                            <span className="tag">{cartItems.length}</span>
                                        </a>
                                    </div>
                                    <div className="offcanvas__social mt-15">
                                        <ul>
                                            <li>
                                                <a href="#!"><i className="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="#!"><i className="fab fa-twitter"></i></a>
                                            </li>
                                            <li>
                                                <a href="#!"><i className="fab fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#!"><i className="fab fa-google-plus-g"></i></a>
                                            </li>
                                            <li>
                                                <a href="#!"><i className="fab fa-linkedin-in"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>

            <a id="scroll_to_top" href="#top" aria-label="Scroll to top"></a>


        {/*
        <div>
          <ul className="navbar">
            <li> <Link to="/">Home</Link>&nbsp;</li>
            <li> <Link to="/About">About</Link>&nbsp;</li>
            <li> <Link to="/orders">My Orders</Link>&nbsp;</li>
            <li><Link to="/Shop">Shop</Link>&nbsp;</li>
            <li><Link to="/Cart">Cart</Link>&nbsp;</li>
            <li><Link to="/profile">Profile</Link>&nbsp;</li>
            <li><Link to="/Signup">Sign up</Link>&nbsp;</li>
            <li><Link to="/Signin">Login</Link>&nbsp;</li>
          </ul>
        </div>
        */}

        
        {/* <Home/> */}
        <RouteSeo />
        <Suspense fallback={<div className="route-loading" aria-busy="true" />}>
        <Routes>
          <Route {...isAuthenticated && <UserOptions user={user} />}/>
          <Route path="/profile" element={<Profile />} />
          <Route path="/Signin" element={<Signin/>}></Route>
          <Route path="/orders" element={<AuthenticatedRoute><MyOrders /></AuthenticatedRoute>}></Route>
          <Route path="/Signup" element={<Signup/>}></Route>
          <Route path="/Login" element={<Login />}></Route>
          <Route path="/admin/Signup" element={<Signin/>}></Route>
          <Route path="/success" element={<OrderSuccess />}></Route>
          {/* <Route path="/profile" element={<ProtectedRoute />}></Route> */}
          {/* <Route path='*' element={<HomePage />} />
          <Route path="/signup" element={<Signup register={registerHandler}></Signup>}></Route>
          <Route path="/signin" element={token !== null ? <HomePage></HomePage> : <Signin ></Signin>} /> */}
          <Route path="/" element={<Home />}></Route>
          <Route path="/product/:id" element={<ProductDetails />}></Route>
          <Route path="/order/:id" element={<OrderDetails />}></Route>
          <Route path="/me/update" element={<UpdateProfile />}></Route>
          <Route path="/password/update" element={<UpdatePassword />}></Route>
          <Route path='/order/confirm' element={<ConfirmOrder />}></Route>
          {/* <Route path='/process/payment' element={<ConfirmPayment />}></Route> */}
          {/* <Route path='/process/payment' element={
            <Elements stripe={loadStripe(stripeApiKey)}>
              <ConfirmPayment/>
            </Elements>}>
          </Route> */}
          {/* <Route path='/process/payment' element={
              <ConfirmPayment/>}>
          </Route> */}
          <Route path='/process/payment' element={
              <ConfirmPayment/>}>
          </Route>
          {/* // {stripeApiKey && ( */}
          {/* //   <Elements stripe={loadStripe(stripeApiKey)}>
          // <Route path='/process/payment' element={<ConfirmPayment />}></Route>
          // </Elements>
          // )}  */}
          <Route path="/password/forgot" element={<ForgotPassword />}></Route>
          <Route path="/password/reset/:token" element={<ResetPassword />}></Route>
          <Route path="/verify-email/:token" element={<VerifyEmail />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/Contact" element={<Contact />}></Route>
          <Route path="/shop" element={<Shop />}></Route>
          <Route path="/ShopCategory" element={<ShopCategory />}></Route>
          <Route path="/shipping" element={<Shipping />}></Route>
          <Route path="/search" element={<Search />}></Route>
          <Route path="/shop/:keyword" element={<Shop />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/Checkout" element={<Checkout />}></Route>
          <Route path="/Error" element={<Error />}></Route>
          <Route path="/Faq" element={<Faq />}></Route>
          <Route path="/ShippingPolicy" element={<ShippingPolicy />}></Route>
          <Route path="/ReturnsRefunds" element={<ReturnsRefunds />}></Route>
          <Route path="/PaymentMethod" element={<PaymentMethod />}></Route>
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />}></Route>
          <Route path="/TermsConditions" element={<TermsConditions />}></Route>
          {/* SEO-friendly URLs (canonical); the CamelCase routes above keep working */}
          <Route path="/shipping-policy" element={<ShippingPolicy />}></Route>
          <Route path="/returns-refunds" element={<ReturnsRefunds />}></Route>
          <Route path="/payment-method" element={<PaymentMethod />}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/terms-conditions" element={<TermsConditions />}></Route>
          <Route path="*" element={<Error />}></Route>

          {/* Admin Routes */}

          <Route path='/admin/dashboard' element={<ProtectedRoute roles={STAFF_ROLES}><Dashboard /></ProtectedRoute>}></Route>
          <Route path='/admin/charges' element={<ProtectedRoute><Charges /></ProtectedRoute>}></Route>
          <Route path='/admin/popup-analytics' element={<ProtectedRoute><PopupAnalytics /></ProtectedRoute>}></Route>
          <Route path='/admin/popup-leads' element={<ProtectedRoute><PopupLeads /></ProtectedRoute>}></Route>
          <Route path='/admin/influencers' element={<ProtectedRoute><Influencers /></ProtectedRoute>}></Route>
          <Route path='/admin/contact-inquiries' element={<ProtectedRoute><ContactInquiries /></ProtectedRoute>}></Route>
          <Route path='/admin/products' element={<ProtectedRoute roles={STAFF_ROLES}><ProductList /></ProtectedRoute>}></Route>
          <Route path='/admin/createProduct' element={<ProtectedRoute roles={STAFF_ROLES}><NewProduct /></ProtectedRoute>}></Route>
          <Route path='/admin/product/:id' element={<ProtectedRoute roles={STAFF_ROLES}><UpdateProduct /></ProtectedRoute>}></Route>
          <Route path='/admin/orders' element={<ProtectedRoute roles={STAFF_ROLES}><OrderList /></ProtectedRoute>}></Route>
          <Route path='/admin/order/:id' element={<ProtectedRoute roles={STAFF_ROLES}><ProcessOrder /></ProtectedRoute>}></Route>
          <Route path='/admin/bogo' element={<ProtectedRoute><BogoOffer /></ProtectedRoute>}></Route>
          <Route path='/admin/freegifts' element={<ProtectedRoute><FreeGiftList /></ProtectedRoute>}></Route>
          <Route path='/admin/freegift/new' element={<ProtectedRoute><FreeGiftForm /></ProtectedRoute>}></Route>
          <Route path='/admin/freegift/:id' element={<ProtectedRoute><FreeGiftForm /></ProtectedRoute>}></Route>
          <Route path='/admin/promo' element={<ProtectedRoute><PromoCodes /></ProtectedRoute>}></Route>
          <Route path='/admin/users' element={<ProtectedRoute><UsersList /></ProtectedRoute>}></Route>
          <Route path='/admin/user/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>}></Route>
          <Route path='/admin/user/:id/credit' element={<ProtectedRoute><UserCredit /></ProtectedRoute>}></Route>
          <Route path='/admin/reviews' element={<ProtectedRoute><ProductReviews /></ProtectedRoute>}></Route>
          <Route path='/:slug' element={<InfluencerRedirect />}></Route>
        </Routes>
        </Suspense>

        {/* <GiveawayPopup /> */}
        <AppFooter />
      </BrowserRouter>
    </>
  )
}

export default App;
